/**
 * @file useHomePage.js
 * @description 首页：分类列表、漫画详情/分类导航
 * @module features/home/composables/useHomePage
 */

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { convertRouteParams } from '@/shared/utils/idHelper'
import { fetchHomeComicApi } from '@/features/home/api/homeApi'

export function useHomePage() {
  const router = useRouter()

  const categories = ref([])

  async function fetchCategories() {
    try {
      const response = await fetchHomeComicApi()
      if (
        (response.data.code === 0 || response.data.code === 200) &&
        response.data.data
      ) {
        const comicVoArray = response.data.data.comicVoArray || []
        categories.value = Array.isArray(comicVoArray)
          ? comicVoArray.filter((cat) => cat && typeof cat === 'object')
          : []
      } else {
        console.error(
          'Failed to fetch categories:',
          response.data.msg || response.data.message
        )
        categories.value = []
      }
    } catch (error) {
      console.error('Error fetching categories:', error)
      categories.value = []
    }
  }

  function goToDetail(id) {
    router.push({
      name: 'ComicDetail',
      params: convertRouteParams({ id }),
    })
  }

  /**
   * 跳转到分类搜索页
   * @param {Object|Array} category 分类对象或 themeCode 数组
   */
  function goToCategory(category) {
    const query = { mode: 'classify' }

    if (Array.isArray(category)) {
      query.themeArray = category.join(',')
    } else if (
      category &&
      typeof category === 'object' &&
      category.themeBigCode
    ) {
      query.bigThemeCode = String(category.themeBigCode)
    }

    router.push({
      name: 'ComicSearch',
      query,
    })
  }

  onMounted(() => {
    const run = () => fetchCategories()
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(run, { timeout: 300 })
    } else {
      setTimeout(run, 150)
    }
  })

  return {
    categories,
    goToDetail,
    goToCategory,
  }
}
